import { createGlobalStyle } from 'styled-components';
import * as normalizeCss from 'normalize.css';

const GlobalStyle = createGlobalStyle`
  ${normalizeCss}

  html,
  body {
    background: #ffffff;
    margin: 0;
    padding: 0;
    height: auto !important;
    font-display: swap;
  }
  
  body.INDnavigation:not(#mainbody) {
    margin-top: 0 !important;
  }

  a {
    text-decoration: none;
    cursor: pointer;
  }

  #root {
    max-width: 100vw;
  }

  .sprite {
    background-image: url(/CV360/Static/images/icons.png) !important;
    float: none !important;
    display: inline-block;
    vertical-align: middle;
    margin: 0 !important;
  }

  .icon-youtube,
  .icon-brightcove,
  .icon-brightcove169,
  .icon-vimeo,
  .icon-ash_video,
  .icon-video169,
  .icon-animation {
    background-position: -31px 1px !important;
    width: 25px !important;
    height: 25px !important;
  }

  .icon-youtube-white,
  .icon-brightcove-white,
  .icon-brightcove169-white,
  .icon-video169-white,
  .icon-vimeo-white,
  .icon-ash_video-white,
  .icon-animation-white {
    background-position: -40px -151px !important;
    width: 30px !important;
    height: 27px !important;
  }

  .icon-scorm,
  .icon-rise,
  .icon-microlearn,
  .icon-jenison_it,
  .icon-jenison,
  .icon-courses,
  .icon-ash_learningguide,
  .icon-ash_articulate,
  .icon-ash_55minuteguide {
    background-position: -3px 0 !important;
    width: 25px !important;
    height: 25px !important;
  }

  .icon-learningbites,
  .icon-ash_audio {
    background-position: -113px -24px !important;
    width: 20px !important;
    height: 25px !important;
  }

  .icon-fastclasses {
    background-position: -132px -23px !important;
    width: 25px !important;
    height: 25px !important;
  }

  .icon-scorm-white,
  .icon-rise-white,
  .icon-microlearn-white,
  .icon-jenison_it-white,
  .icon-jenison-white,
  .icon-courses-white,
  .icon-ash_learningguide-white,
  .icon-ash_articulate-white,
  .icon-ash_55minuteguide-white {
    background-position: -6px -153px !important;
    width: 25px !important;
    height: 27px !important;
  }

  .icon-fastclasses-white {
    background-position: -194px -153px !important;
    width: 25px !important;
    height: 27px !important;
  }

  .icon-learningbites-white,
  .icon-ash_audio-white {
    background-position: -166px -153px !important;
    width: 25px !important;
    height: 27px !important;
  }

  .icon-tutorial,
  .icon-article,
  .icon-tests,
  .icon-ash_journalarticle,
  .icon-ash_bookreview,
  .icon-ash_publication {
    background-position: -60px 2px !important;
    width: 25px !important;
    height: 25px !important;
  }

  .icon-tutorial-white,
  .icon-article-white,
  .icon-ash_journalarticle-white,
  .icon-ash_bookreview-white,
  .icon-ash_publication-white {
    background-position: -78px -153px !important;
    width: 25px !important;
    height: 27px !important;
  }

  .icon-hottips,
  .icon-ash_infographic,
  .icon-ash_hottopic {
    background-position: -113px 1px !important;
    width: 25px !important;
    height: 25px !important;
  }

  .icon-hottips-white,
  .icon-ash_infographic-white,
  .icon-ash_hottopic-white {
    background-position: -136px -152px !important;
    width: 25px !important;
    height: 27px !important;
  }

  .icon-undefined {
    background: none;
    width: 25px !important;
    height: 25px !important;
    margin: 5px 0 !important;
  }

  .video-js {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }

  .p3sdk-container {
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    width: 100% !important;
    height: 100% !important;
  }

  .p3sdk-interactive-transcript-component {
    height: 100%;
  }

  .p3sdk-interactive-transcript {
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .p3sdk-interactive-transcript-content {
    padding-bottom: 0;
    height: 100% !important;
    margin-top: 0;
    margin-bottom: 0;
    overflow-y: auto;
  }

  .p3sdk-interactive-transcript-content p:last-child {
    margin-bottom: 0 !important;
  }

  .p3sdk-interactive-transcript-bottom-bar {
    display: none;
  }

  .cursor-pointer {
    transition: all 0.3s ease;
    cursor: pointer;
    margin: 0 0 2px 4px;
    padding: 0;
    background-color: transparent !important;
    border: none;
    color: inherit;
    display: inline-block;
    line-height: 1;

    &:hover,
    &:active {
      color: ${({ theme }) => theme.primary};
    }

    &:focus {
      color: inherit;
    }
  }

  .fs-11 {
    font-size: 11px;
  }

  .fs-12 {
    font-size: 12px;
  }

  .fs-14 {
    font-size: 14px;
  }

  .fs-16 {
    font-size: 16px;
  }

  .fs-18 {
    font-size: 18px;
  }

  .fs-20 {
    font-size: 20px;
  }

  .fs-22 {
    font-size: 22px;
  }

  .fs-24 {
    font-size: 24px;
  }
  
  body.modal-open {
    overflow: auto !important;
    padding-right: 0 !important;
  }
  
  html:not(#INDdummy) body:not(#INDdummy).INDwhiteblack,
  html:not(#INDdummy) body:not(#INDdummy).INDwhiteblack > :not(#INDWrap),
  html:not(#INDdummy) body:not(#INDdummy).INDwhiteblack > :not(#INDWrap) :not(img):not(video) {
    fill: #ffffff;
  }

  html:not(#INDdummy) body:not(#INDdummy).INDwhiteblack #root > .container-lg ~ div:before {
    background: rgba(255,255,255,0.2) !important;
  }

  html:not(#INDdummy) body:not(#INDdummy).INDwhiteblack #root > .container-lg ~ div > div {
    color: #000000 !important;
  } 

  html:not(#INDdummy) body:not(#INDdummy).INDwhiteblack,
  html:not(#INDdummy) body:not(#INDdummy).INDwhiteblack > :not(#INDWrap),
  html:not(#INDdummy) body:not(#INDdummy).INDwhiteblack > :not(#INDWrap) *:not(img):not(video) {
    fill: #000000 !important;
    color: #000000 !important;
    background-color: rgba(255, 255, 255, 0.5) !important;
  }

  html:not(#INDdummy) body:not(#INDdummy).INDwhiteblack #root .video-js .vjs-text-track-display,
  html:not(#INDdummy) body:not(#INDdummy).INDwhiteblack #root .video-js .vjs-text-track-display div {
    background: none !important;
  }

  html:not(#INDdummy) body:not(#INDdummy).INDblackwhite,
  html:not(#INDdummy) body:not(#INDdummy).INDblackwhite > :not(#INDWrap),
  html:not(#INDdummy) body:not(#INDdummy).INDblackwhite > :not(#INDWrap) :not(img):not(video) {
    fill: #ffffff;
    color: #ffffff !important;
    background-color: rgba(0, 0, 0, 0.5) !important;
  }

  html:not(#INDdummy) body:not(#INDdummy).INDblackwhite #root #dropdown-basic,
  html:not(#INDdummy) body:not(#INDdummy).INDblackwhite #root #tips > div > div:first-child,
  html:not(#INDdummy) body:not(#INDdummy).INDblackwhite #root .video-js .vjs-text-track-display,
  html:not(#INDdummy) body:not(#INDdummy).INDblackwhite #root .video-js .vjs-text-track-display div {
    background: none !important;
  }

  html:not(#INDdummy) body:not(#INDdummy).INDblackwhite .card[header] {
    border: 1px solid gold;
  }

  html:not(#INDdummy) body:not(#INDdummy).INDblackwhite #root .btn.btn-light[type=button],
  html:not(#INDdummy) body:not(#INDdummy).INDblackwhite #root .btn.btn-light[type=button]:hover,
  html:not(#INDdummy) body:not(#INDdummy).INDblackwhite #root .btn.btn-primary,
  html:not(#INDdummy) body:not(#INDdummy).INDblackwhite #root .btn.btn-primary:hover,
  html:not(#INDdummy) body:not(#INDdummy).INDblackwhite #root .btn.btn-outline-primary,
  html:not(#INDdummy) body:not(#INDdummy).INDblackwhite #root .btn.btn-outline-primary:hover,
  html:not(#INDdummy) body.INDcolorscheme > :not(#INDWrap) #root .btn.btn-light,
  html:not(#INDdummy) body.INDcolorscheme > :not(#INDWrap) #root .btn.btn-light:hover,
  html:not(#INDdummy) body.INDcolorscheme > :not(#INDWrap) #root .btn.btn-primary,
  html:not(#INDdummy) body.INDcolorscheme > :not(#INDWrap) #root .btn.btn-primary:hover,
  html:not(#INDdummy) body.INDcolorscheme > :not(#INDWrap) #root .btn.btn-outline-primary,
  html:not(#INDdummy) body.INDcolorscheme > :not(#INDWrap) #root .btn.btn-outline-primary:hover,
  html:not(#INDdummy) body.INDcolorscheme > :not(#INDWrap) .card-item-js > .card > .d-flex > .d-flex > .sc-iqAbSa,
  html:not(#INDdummy) body.INDcolorscheme > :not(#INDWrap) .card-item-js > .card > .d-flex > .d-flex > .sc-iqAbSa:hover {
    background: black !important;
    border: 1px solid gold !important;
  }

  html:not(#INDdummy) body:not(#INDdummy).INDblackwhite #root > .container-lg ~ div:before {
    background: rgba(0,0,0,0.2) !important;
  }

  html:not(#INDdummy) body:not(#INDdummy).INDblackwhite #root > .container-lg ~ div > div {
    color: #ffffff !important;
  }

  html:not(#INDdummy) body:not(#INDdummy).INDblackwhite #root #chartdiv g[style*='touch-action: none; user-select: none'] > g > g > g > g {
    stroke: #ffffff;
    fill-opacity: 1;
    stroke-opacity: 0.5;
  }

  @media (min-width: 960px) {
    #root > .p-lg-0 {
      padding: 0 !important;
    }
  }

  @media print {
    * {
      color: #000000;
    }
    body, html, #wrapper {
      height: 100%;
    }
    .no-print-element  {
      display: none;
    }
    .print-element {
      display: block;
    }
  }
`;

export default GlobalStyle;
